'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});

var _createClass = function () {
  function defineProperties(target, props) {
    for (var i = 0; i < props.length; i++) {
      var descriptor = props[i];
      descriptor.enumerable = descriptor.enumerable || false;
      descriptor.configurable = true;
      if ("value" in descriptor) descriptor.writable = true;
      Object.defineProperty(target, descriptor.key, descriptor);
    }
  }

  return function (Constructor, protoProps, staticProps) {
    if (protoProps) defineProperties(Constructor.prototype, protoProps);
    if (staticProps) defineProperties(Constructor, staticProps);
    return Constructor;
  };
}();

var _templateObject = _taggedTemplateLiteral(['\n        max-width: 360px;\n      '], ['\n        max-width: 360px;\n      ']),
    _templateObject2 = _taggedTemplateLiteral(['\n        max-width: 600px;\n      '], ['\n        max-width: 600px;\n      ']),
    _templateObject3 = _taggedTemplateLiteral(['\n        max-width: 1040px;\n        ', ';\n      '], ['\n        max-width: 1040px;\n        ', ';\n      ']),
    _templateObject4 = _taggedTemplateLiteral(['max-width: 100%;'], ['max-width: 100%;']),
    _templateObject5 = _taggedTemplateLiteral(['\n        max-width: 100%;\n      '], ['\n        max-width: 100%;\n      ']),
    _templateObject6 = _taggedTemplateLiteral(['\n  width: 100%;\n  max-height: 100vh;\n  padding: 0px 20px;\n  margin: 0px auto;\n  transform: ', ';\n  ', ';\n  ', ';\n  ', ';\n'], ['\n  width: 100%;\n  max-height: 100vh;\n  padding: 0px 20px;\n  margin: 0px auto;\n  transform: ', ';\n  ', ';\n  ', ';\n  ', ';\n']),
    _templateObject7 = _taggedTemplateLiteral(['padding: 0px;'], ['padding: 0px;']);

var _react = require('react');

var _react2 = _interopRequireDefault(_react);

var _propTypes = require('prop-types');

var _propTypes2 = _interopRequireDefault(_propTypes);

var _styledComponents = require('styled-components');

var _styledComponents2 = _interopRequireDefault(_styledComponents);

var _polished = require('polished');

var _reactOnclickoutside = require('react-onclickoutside');

var _reactOnclickoutside2 = _interopRequireDefault(_reactOnclickoutside);

var _reactDeviceDetect = require('react-device-detect');

var _media = require('../../../libs/media');

function _interopRequireDefault(obj) {
  return obj && obj.__esModule ? obj : {
    default: obj
  };
}

function _objectWithoutProperties(obj, keys) {
  var target = {};

  for (var i in obj) {
    if (keys.indexOf(i) >= 0) continue;
    if (!Object.prototype.hasOwnProperty.call(obj, i)) continue;
    target[i] = obj[i];
  }

  return target;
}

function _classCallCheck(instance, Constructor) {
  if (!(instance instanceof Constructor)) {
    throw new TypeError("Cannot call a class as a function");
  }
}

function _possibleConstructorReturn(self, call) {
  if (!self) {
    throw new ReferenceError("this hasn't been initialised - super() hasn't been called");
  }

  return call && (typeof call === "object" || typeof call === "function") ? call : self;
}

function _inherits(subClass, superClass) {
  if (typeof superClass !== "function" && superClass !== null) {
    throw new TypeError("Super expression must either be null or a function, not " + typeof superClass);
  }

  subClass.prototype = Object.create(superClass && superClass.prototype, {
    constructor: {
      value: subClass,
      enumerable: false,
      writable: true,
      configurable: true
    }
  });
  if (superClass) Object.setPrototypeOf ? Object.setPrototypeOf(subClass, superClass) : subClass.__proto__ = superClass;
}

function _taggedTemplateLiteral(strings, raw) {
  return Object.freeze(Object.defineProperties(strings, {
    raw: {
      value: Object.freeze(raw)
    }
  }));
} // Libs


var sizes = function sizes(_ref) {
  var size = _ref.size;

  switch (size) {
    case 'small':
      return (0, _styledComponents.css)(_templateObject);

    case 'medium':
      return (0, _styledComponents.css)(_templateObject2);

    case 'large':
      return (0, _styledComponents.css)(_templateObject3, _media.media.m(_templateObject4));

    case 'full':
      return (0, _styledComponents.css)(_templateObject5);

    default:
      return (0, _styledComponents.css)(_templateObject2);
  }
};

var Container = _styledComponents2.default.div(_templateObject6, function (_ref2) {
  var visible = _ref2.visible;
  return visible ? 'none' : 'translateY(-50px)';
}, (0, _polished.transitions)('transform .3s ease-in-out'), sizes, _media.media.m(_templateObject7));

var ModalCard = function (_Component) {
  _inherits(ModalCard, _Component);

  function ModalCard() {
    var _ref3;

    var _temp, _this, _ret;

    _classCallCheck(this, ModalCard);

    for (var _len = arguments.length, args = Array(_len), _key = 0; _key < _len; _key++) {
      args[_key] = arguments[_key];
    }

    return _ret = (_temp = (_this = _possibleConstructorReturn(this, (_ref3 = ModalCard.__proto__ || Object.getPrototypeOf(ModalCard)).call.apply(_ref3, [this].concat(args))), _this), _this.handleClickOutside = function () {
      if (_reactDeviceDetect.isMobile) return;

      _this.props.onClose();
    }, _temp), _possibleConstructorReturn(_this, _ret);
  }

  _createClass(ModalCard, [{
    key: 'render',
    value: function render() {
      var _props = this.props,
          children = _props.children,
          onClose = _props.onClose,
          props = _objectWithoutProperties(_props, ['children', 'onClose']);

      return _react2.default.createElement(Container, props, children);
    }
  }]);

  return ModalCard;
}(_react.Component);

ModalCard.propTypes = {
  size: _propTypes2.default.string,
  visible: _propTypes2.default.bool,
  children: _propTypes2.default.node,
  onClose: _propTypes2.default.func
};
exports.default = (0, _reactOnclickoutside2.default)(ModalCard);